import { GO_BOARD_MOKA_GAME_END_PASS_COUNT, GO_BOARD_MOKA_SELF_PLAY_MAXIMUM_MOVE_COUNT } from "@/constants";
const isMokaGameOver = gameState => gameState.consecutivePassCount >= GO_BOARD_MOKA_GAME_END_PASS_COUNT || gameState.moveCount >= GO_BOARD_MOKA_SELF_PLAY_MAXIMUM_MOVE_COUNT;
export { isMokaGameOver };